import { insideIframe, sendMessage } from './message-sender';

if (insideIframe) {
    // Fix scrollbar issues since we're in an iframe
    document.body.style.margin = '0';
    document.body.style.display = 'flex';
    document.body.style.flexDirection = 'column';
    document.body.style.overflow = 'hidden';

    const resizeObserver = new ResizeObserver(function(entries) {
        entries.forEach(entry => {
            requestHeight(entry.contentRect.height);
        });
    });
    resizeObserver.observe(document.body);
}

function requestHeight(height) {
    if (height == requestHeight.lastRequestedHeight) {
        return;
    }

    sendMessage({
        DRF: {
            subject: 'request-resize',
            height: height,
        },
    });
    requestHeight.lastRequestedHeight = height;
}